import { HttpClient } from "@angular/common/http";
import { AppEndpoint } from "app/app.endpoints";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

import { HttpRequestService } from "app/auth/service/http-request.service";
import { AuthenticationService } from ".";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class SubscriptionService {
  private url = AppEndpoint.BASE_URL + "/private" + "/subscriptions";
  constructor(
    private _httpService: HttpRequestService,
    private _toastrService: ToastrService,
    private _auth: AuthenticationService,
    private _http: HttpClient
  ) {}

  create(conf): Promise<any> {
    conf.created_by = this.userId;
    return new Promise((resolve, reject) => {
      this._httpService
        .Subscription(this.companyId)
        .post(conf)
        .subscribe(
          (response: any) => {
            resolve(response);
          },
          (err) => {
            this._toastrService.error(
              "Error por favor intente nuevamente.",
              "Error!",
              {
                toastClass: "toast ngx-toastr",
                closeButton: true,
              }
            );
            reject(err);
          }
        );
    });
  }

  getTotalSmsAssigned = (companyOwnerId: string): Observable<any> =>
    this._http.get(`${this.url}/total-sms/${companyOwnerId}`);

  getAll(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._httpService
        .Subscriptions(this.companyId)
        .get()
        .subscribe(
          (response: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  update = (subscriptionId: string, sender): Observable<any> => {
    sender.updated_by = this._auth.userId;
    return this._httpService
      .Subscription(this._auth.companyId, subscriptionId)
      .put(sender);
  };

  getCompanySubscription(companyId: string): Observable<any> {
    return this._http.get<any>(`${AppEndpoint.BASE_URL + "/private/companies/subscription/" + companyId}`);
    //return this._httpService.Subscription(this.companyId, companyId).get();
  }

  getCompanySendStatus = (sendType, companyId = null): Observable<any> =>
    this._http.get(`${this.url}/company-send-status`, {
      params: { sendType, companyId: companyId || this._auth.companyId },
    });

  updateTotal(conf, companyId): Promise<any> {
    conf.updated_by = this.userId;
    return new Promise((resolve, reject) => {
      this._httpService
        .Subscription(this.companyId, companyId)
        .put(conf)
        .subscribe(
          (response: any) => {
            this._toastrService.success("operacion exitosa", "Success!", {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
            resolve(response);
          },
          (err) => {
            this._toastrService.error(
              "Error por favor intente nuevamente.",
              "Error!",
              {
                toastClass: "toast ngx-toastr",
                closeButton: true,
              }
            );
            reject(err);
          }
        );
    });
  }

  delete(conf, companyId): Promise<any> {
    conf.updated_by = this.userId;
    return new Promise((resolve, reject) => {
      this._httpService
        .Subscription(this.companyId, companyId)
        .put(conf)
        .subscribe(
          (response: any) => {
            this._toastrService.success("operacion exitosa", "Success!", {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
            resolve(response);
          },
          (err) => {
            this._toastrService.error(
              "Error por favor intente nuevamente.",
              "Error!",
              {
                toastClass: "toast ngx-toastr",
                closeButton: true,
              }
            );
            reject(err);
          }
        );
    });
  }

  getCompanySubscriptionSummary = (): Observable<any> =>
    this._http.get(`${this.url}/company-subscription-summary`);

  get companyId() {
    return this._auth.companyId;
  }

  get userId() {
    return this._auth.userId;
  }
}
